import {
    ChangeDetectionStrategy,
    Component,
} from "@angular/core";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { TranslateModule } from "@ngx-translate/core";
import { LivechatButtonDirective } from "../../../live-chat/livechat-button.directive";

@Component({
    selector: "ls-fixed-action",
    imports: [
        TranslateModule,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        IconComponent,
        LivechatButtonDirective,
    ],
    templateUrl: "./fixed-action.component.html",
    styleUrl: "./fixed-action.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
export class FixedActionComponent {
}
